export const MyHealthConnectionIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
            <circle cx="9" cy="12" r="5.25" transform="rotate(90 9 12)" stroke="#171C2E" stroke-opacity="0.8"
                    stroke-width="1.5"/>
            <circle cx="15" cy="12" r="5.25" transform="rotate(90 15 12)" stroke="#1C1D21" stroke-width="1.5"/>
        </svg>
    )
}